import React from 'react';
import PropTypes from 'prop-types';

import TabView, { Tab } from '../../../components/TabView';
import { hasPermission } from '../../../utils/userPermissions';
import { isSuperUser, isShipper } from '../../../utils/userRoles';
import { DeviceInvoicesMainTabs, DeviceInvoicesTypes } from './helpers';
import DeviceInvoicesTabs from './DeviceInvoicesTabs';
import InvoiceData from './InvoiceData';
import Pricing from './Pricing';

function DeviceInvoices({activeTab}) {
  return (
    <TabView activeTab={activeTab} routeMode noSwiping>
      {(hasPermission(DeviceInvoicesMainTabs.INITIAL.permission) || isSuperUser() || isShipper()) && (
        <Tab name={DeviceInvoicesMainTabs.INITIAL.name} path={DeviceInvoicesMainTabs.INITIAL.url}>
          <DeviceInvoicesTabs invoiceType={DeviceInvoicesTypes.INITIAL} />
        </Tab>
      )}
      {(hasPermission(DeviceInvoicesMainTabs.RECURRING.permission) || isSuperUser() || isShipper()) && (
        <Tab name={DeviceInvoicesMainTabs.RECURRING.name} path={DeviceInvoicesMainTabs.RECURRING.url}>
          <DeviceInvoicesTabs invoiceType={DeviceInvoicesTypes.RECURRING} />
        </Tab>
      )}
      {(hasPermission(DeviceInvoicesMainTabs.INVOICE_DATA.permission) || isSuperUser() || isShipper()) && (
        <Tab name={DeviceInvoicesMainTabs.INVOICE_DATA.name} path={DeviceInvoicesMainTabs.INVOICE_DATA.url}>
          <InvoiceData />
        </Tab>
      )}
      {(isSuperUser() || isShipper()) && (
        <Tab name={DeviceInvoicesMainTabs.PRICING.name} path={DeviceInvoicesMainTabs.PRICING.url}>
          <Pricing />
        </Tab>
      )}
    </TabView>
  );
}

DeviceInvoices.propTypes = {
  activeTab: PropTypes.string,
};

export default DeviceInvoices;
